'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportService = exports.ReportService = function () {
    function ReportService(winresCloudService) {
        _classCallCheck(this, ReportService);

        this.winresCloudService = winresCloudService;
    }

    _createClass(ReportService, [{
        key: 'getAvailableFields',
        value: function getAvailableFields(reportType) {
            return this.winresCloudService.makeAuthenticatedRequest('ReportGetAvailableFields', {
                "ReportType": reportType
            });
        }
    }, {
        key: 'getAvailableTokens',
        value: function getAvailableTokens(reportType) {
            return this.winresCloudService.makeAuthenticatedRequest('ReportGetAvailableTokens', {
                "ReportType": reportType
            });
        }
    }, {
        key: 'getReports',
        value: function getReports(reportType) {
            return this.winresCloudService.makeAuthenticatedRequest('ReportGetReports', {
                "ReportType": reportType
            });
        }
    }, {
        key: 'getReport',
        value: function getReport(reportType, reportID) {
            return this.winresCloudService.makeAuthenticatedRequest('ReportGetReport', {
                "ReportType": reportType,
                "ReportID": reportID
            },
            /*withOverlay=*/true).then(function (report) {
                if (!report) {
                    throw new Error('Failed to get report ' + reportID + ' of type "' + reportType + '".');
                }

                // Convert deprecated headers into new format.
                // Report header, title, footer
                if (!report.HeaderPatternMultilingual) {
                    report.HeaderPatternMultilingual = { fi: report.HeaderPattern };
                }
                if (!report.FooterPatternMultilingual) {
                    report.FooterPatternMultilingual = { fi: report.FooterPattern };
                }
                if (!report.TitleMultilingual) {
                    report.TitleMultilingual = { fi: report.Title };
                }

                // Group footers
                _.each(report.Groups, function (group) {
                    if (!group.AggregateTemplateMultilingual) {
                        group.AggregateTemplateMultilingual = {
                            fi: group.AggregateTemplate
                        };
                    }
                    // Report field titleoverrides.
                    _.each(group.Fields, function (field) {
                        if (!group.TitleOverrideMultilingual) {
                            group.TitleOverrideMultilingual = {
                                fi: group.TitleOverride
                            };
                        }
                    });
                });

                return report;
            });
        }
    }, {
        key: 'saveReport',
        value: function saveReport(reportType, report) {
            return this.winresCloudService.makeAuthenticatedRequest('ReportSaveReport', {
                "ReportType": reportType,
                "Report": report
            },
            /*withOverlay=*/true);
        }
    }, {
        key: 'reportGenerate',
        value: function reportGenerate(reportType, searchCriteria, reportDefinition, language) {
            return this.winresCloudService.makeAuthenticatedRequest('ReportGenerate', {
                "SearchCriteria": searchCriteria,
                "ReportType": reportType,
                "Report": reportDefinition,
                "Language": language
            },
            /*withOverlay=*/true);
        }
    }]);

    return ReportService;
}();

ReportService.$inject = ['winresCloudService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/reportService.js
// module id = 564
// module chunks = 2